import { Layout } from '@/components/Layout/Layout';
import ClientProductsPage from 'components/PageLevelComponents/ClientProductsPage';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import type { GetServerSideProps } from 'next';
import { ProductsPageController } from 'server/controller/page/products/productsPageController';
import type { IProductsPageResource } from 'server/resource/page/productsPageResource';

const RootPage = (props: IProductsPageResource) => {
  const {
    metaData,
    searchItemLabels,
    recipeCopy,
    breadcrumbsCMSData,
    footerNavData,
    footerImage,
    locale,
    searchOverlayData,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    difficultyCopy,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    landingPage,
    dynamicPageComponents,
    landingPageComponents,
    pathTranslations,
    userToken,
    globalDictionary,
  } = props;

  return (
    <Layout
      themeName={undefined}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
      globalDictionary={globalDictionary}
    >
      <ClientProductsPage
        breadcrumbsCMSData={breadcrumbsCMSData}
        recipeCopy={recipeCopy}
        searchItemLabels={searchItemLabels as Record<string, string>}
        searchOverlayData={searchOverlayData}
        difficultyCopy={difficultyCopy as Record<string, string>}
        dynamicPageComponents={dynamicPageComponents}
        landingPage={landingPage}
        landingPageComponents={landingPageComponents}
      />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];
  return ProductsPageController.getCachedProductsPageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    userToken: anonymousToken ?? '',
  });
};

export default RootPage;
